export enum GolfTechType{
    Organizer = 1,
    Golfer = 2,
    Course = 3,
    CheckIn = 4,
    GlobalAdmin = 5,
    Simulator = 6
}